import { handleActions } from 'redux-actions';

import { actions } from './actions';
import * as selectors from './selectors';

export { actions };
export { sagas } from './sagas';
export { selectors };

const CHAT_VIEW_THREADS = 'threads';
const PANEL_DEFAULT_WIDTH = 640;

const defaultState = {
  isOpen: false,
  panelWidth: PANEL_DEFAULT_WIDTH,
  activeView: CHAT_VIEW_THREADS,
  selectedThreadId: null,
};

export const reducer = handleActions(
  {
    [actions.setOpen]: (state, { payload }) => ({
      ...state,
      isOpen: Boolean(payload),
    }),
    [actions.setPanelWidth]: (state, { payload }) => ({
      ...state,
      panelWidth: Number.isFinite(payload)
        ? Math.round(payload)
        : state.panelWidth,
    }),
    [actions.setActiveView]: (state, { payload }) => ({
      ...state,
      activeView: payload || state.activeView,
    }),
    [actions.setSelectedThreadId]: (state, { payload }) => ({
      ...state,
      selectedThreadId:
        payload === null || payload === undefined ? null : String(payload),
    }),
  },
  defaultState
);
